import { getListings } from 'restaurantAdmin/operations/listings/apiHelpers';

export type MaxGuestListingConflictEvaluation =
  | { outcome: 'unchanged' }
  | { outcome: 'noConflict' }
  | { outcome: 'listingConflict' }
  | { outcome: 'fetchFailed'; error: unknown };

/**
 * When lowering max guest count, published listings may still advertise a higher party size.
 * Used by General settings save: conflict opens a confirmation modal (not an inline field error).
 */
export async function evaluateMaxGuestListingConflict(
  restaurantId: string,
  persistedMaxReservationGuests: number,
  nextMaxGuestCount: number,
): Promise<MaxGuestListingConflictEvaluation> {
  if (nextMaxGuestCount === persistedMaxReservationGuests) {
    return { outcome: 'unchanged' };
  }

  try {
    const listings = await getListings(restaurantId);
    const hasListingMaxAboveNewLimit = listings.some(
      (listing) => listing.maximumGuests > nextMaxGuestCount,
    );
    return hasListingMaxAboveNewLimit
      ? { outcome: 'listingConflict' }
      : { outcome: 'noConflict' };
  } catch (error) {
    return { outcome: 'fetchFailed', error };
  }
}
